export enum ValidateWorkPlanStatus {
  Valid = 1,
  Breached = 2,
}

export const VALIDATE_WORK_PLAN_STATUS_TITLES: any = {
  [ValidateWorkPlanStatus.Valid]: 'ok',
  [ValidateWorkPlanStatus.Breached]: 'breached',
};
